import React from 'react'

function LegendStatsCardTemplate({stats}) {
    return (
        <div className="row">
            {stats?.map((player, index) => {
                return (
                    <div key={index} className="col-md-4 col-lg-3 col-xl-3 my-2">
                        <div className="card">
                            <img src={player.player_image} alt={player.player_name} />
                            <div className="card-body">
                                <p className="font-weight-bold">{player.player_name}</p>
                                <div className="text-muted" style={{fontSize: "0.75rem"}}>
                                    <p>Kamper: {player.fixtures}</p>
                                    <p>Mål: {player.goals}</p>
                                    <p>Assist: {player.assists}</p>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
export default LegendStatsCardTemplate